<template>
	<div>


<div
	class="node"
	@click="expanded = !expanded"
	:style="{ 'margin-left': `${depth * 20}px` }"
>
	<span class="type"></span>
	<h1>{{ node.name }}</h1>
</div>
<ul v-if="expanded">
	<TreeView
		v-for="child in node.children"
		:key="child.name"
		:node="child"
		:depth:="depth + 1"
	>
	</TreeView>
</ul>
	</div>
</template>
<script>
	export default {
		name: "TreeView",
		props: {
			node: Object,
			depth: {
				type: Number,
				default: 0,
			},
		},
		data() {
			return {
				expanded: false,
			};
		},
	}
</script>
